import type { Breadcrumb, ErrorEvent } from '@sentry/react'

// Campos que nunca podem sair em texto claro para o Sentry (CLAUDE.md 3.7.1).
const SENSITIVE_KEY_PATTERN =
  /^(authorization|cookie|token|accesstoken|refreshtoken|devicetoken|hardwareid|email|ipaddress|postalcode|lat|lng|latitude|longitude)$/i

function redactObject<T>(value: T): T {
  if (Array.isArray(value)) return value.map(redactObject) as unknown as T
  if (value && typeof value === 'object') {
    const result: Record<string, unknown> = {}
    for (const [key, v] of Object.entries(value as Record<string, unknown>)) {
      result[key] = SENSITIVE_KEY_PATTERN.test(key) ? '[Redacted]' : redactObject(v)
    }
    return result as T
  }
  return value
}

/** Remove PII/segredos de eventos antes de enviar ao Sentry (headers, request data, extra, contexts). */
export function sanitizeSentryEvent(event: ErrorEvent): ErrorEvent {
  if (event.request) {
    event.request = redactObject(event.request)
  }
  if (event.extra) {
    event.extra = redactObject(event.extra)
  }
  if (event.contexts) {
    event.contexts = redactObject(event.contexts)
  }
  return event
}

/** Remove PII/segredos de breadcrumbs (fetch/xhr/console) antes de anexá-los ao evento. */
export function sanitizeSentryBreadcrumb(breadcrumb: Breadcrumb): Breadcrumb {
  if (breadcrumb.data) {
    breadcrumb.data = redactObject(breadcrumb.data)
  }
  return breadcrumb
}
